import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();

        this.GetInfo();
        await this.GetAllAcademicLevels();
        await this.GetAllSubjects();
        await this.GetAllInstructors();
        await this.GetAllStudents();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: ' الإشعارات ',
            ScreenTitleSingle: ' إشعار ',
            ScreenTitleSingleAl: 'الإشعار',

            Info: [],
            Statistics: [],

            AddDialog: false,

            SelectedItem: '',

            ruleForm: {
                Id: '',
                Type: '',
                AcademicLevelsId: '',
                AcademicSpecializationId: '',
                SubjectId: '',
                TargetId: '',
                Title: '',
                Content: '',
            },
            rules: {
                Type: this.$helper.Required(),
                TargetId: this.$helper.Required(),
                Title: this.$helper.Required(),
                Content: this.$helper.Required(),
            },
        };
    },



    methods: {

        ClearTarget() {
            this.ruleForm.TargetId = '';
        },



        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();

            if (this.Search === null) this.Search = '';

            this.$http.GetNotifications(this.pageNo, this.pageSize, this.Search.trim())
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        onPageSizeChanged(newSize) {
            this.pageSize = newSize;
            this.pageNo = 1;
            this.GetInfo(1);
        },

        // Web P0 FIX: open a notification's detail and mark it read.
        // Shows the list row immediately, then enriches from the detail endpoint
        // and (if still unread) flips it to read, refreshing the list so the
        // read badge updates.
        ViewDetails(item) {
            this.SelectedItem = item;

            this.$http.GetNotificationDetail(item.id)
                .then(response => {
                    if (response.data && response.data.info) {
                        this.SelectedItem = response.data.info;
                    }
                })
                .catch(() => { /* keep the list-row data already shown */ });

            if (item.isRead == 0) {
                this.$http.MarkNotificationRead(item.id)
                    .then(() => { this.GetInfo(this.pageNo); })
                    .catch(() => { /* non-fatal: detail still opens */ });
            }
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);
                    if (this.ruleForm.Type == 1)
                        this.ruleForm.TargetId = Number(0);
                    this.$blockUI.Start();
                    this.$http.PushNotifications(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();

                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },
    }
}
